import React, { useState, useEffect, useContext } from 'react';
import { Row, Col } from 'react-bootstrap'
import { PROVIDER_ADD, PROVIDER_ALL, PROVIDER_UPDATE } from '../../../api/Routes';
import AddProveedores from './AddProveedores';
import ProveedoresList from './ProveedoresList';
import Get from '../../../api/Get';
import Post from '../../../api/Post';
import Put from '../../../api/Put';
import { authContext } from '../../../context/AuthContext';
import { toBool } from '../../../utils/toBool';
import LoadingList from '../../../loader/LoadingList';

import '../../../styles/catalogos/catalogos.css'
import ComponentModalErrorSever from '../../../components/ComponentModalErrorSever';

function ProveedoresIndex(){

    //Parametros para actualizar la tabla
    const [items, setItems] = useState([])
    const [initialValues, setInitialValues] = useState({name:'', priority: ''})
    const [loading, setLoading] = useState(false)
    const [loadData, setLoadData] = useState(true)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    useEffect(() => {
        setLoading(true)

        Get({url: PROVIDER_ALL, access_token: auth.data.access_token})
        .then((resp) => {
            setItems(resp.data.data.response.content)
            setLoading(false)
        })
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })
    }, [])

    const agregar = (values) => {
        values.active = true;
        values.companies = [auth.data.company]
        setLoading(true)
        Post({url: PROVIDER_ADD, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            //console.log(response)
            setItems(prev=>[...prev, response.data.data])
            setInitialValues({name:''})
            
            setLoading(false)  
            
        })                
        .catch((error) => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)
        })

    }

    const editar = (values) =>{
        
        if(toBool(values.active)){
            values.companies.push(auth.data.company)
        }else{
            let arr = values.companies.filter(el => el.id !== auth.data.company.id)
            values.companies = arr
        }        

        Put({url: PROVIDER_UPDATE, data: values, header:true, access_token:auth.data.access_token})
        .then((response) => {
            setLoadData(!loadData)
            setLoading(false)        
        })                
        .catch((error) => {
            setLoading(false)        
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
    }

    return(<>
        {loading && <LoadingList texto='' />}

        <div className="body">
            
            <Row>
                <Col xs="6" md="6">
                    {!loading && <AddProveedores agregar={agregar} initialValues={initialValues} />}
                </Col>
                <Col xs="6" md="6">
                    <ProveedoresList items={items} 
                        editar={editar}
                        auth={auth}
                    />
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever 
            show={showModalError}
            handleClose={handleClose}
            error={errorServer}
        />
    </>)
}

export default ProveedoresIndex